export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID de tienda: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Usuario: ',
      placeholder: 'Usuario para la autenticación entre tu tienda y WinOrder',
      validation: {
        required: 'El usuario no puede estar vacío',
        min: 'La longitud mínima del usuario es de 3 caracteres',
      },
    },
    password: {
      label: 'Contraseña: ',
      placeholder: 'Contraseña para la autenticación entre tu tienda y WinOrder',
      validation: {
        required: 'La contraseña no puede estar vacía',
        complexity: 'La contraseña debe tener al menos 8 caracteres y contener al menos una letra',
      },
    },
  },
  labels: {
    credentials: 'Credenciales:',
  },
  instructions: {
    title: 'Instrucciones de configuración:',
    step_1: 'Abre «Configuración» → «Configuración del programa» en WinOrder.',
    step_2: 'En la parte superior encontrarás el botón «Configuración de tienda online».',
    step_3:
      'En la siguiente ventana verás todas las tiendas preconfiguradas en WinOrder. Selecciona «FoodAmigos» y haz clic en «Siguiente».',
    step_4:
      'En la siguiente ventana, reemplaza <0>{{storeid_placeholder}}</0> por <1>{{company_id}}</1> en el campo «URL del servicio web». <br />El resultado final debería verse así: <2>{{url}}</2>',
    step_5: 'En la misma ventana, introduce <ClickToCopy>{{username}}</ClickToCopy> en el campo «Usuario».',
    step_6:
      'En la misma ventana, introduce <ClickToCopy>{{password}}</ClickToCopy> en el campo «Contraseña». Luego haz clic en «Siguiente».',
    step_7:
      'WinOrder comprueba ahora la conexión con la interfaz de FoodAmigos. Haz clic en «Siguiente» y en la siguiente ventana en «Finalizar».',
    step_8: 'Guarda la configuración.',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Cambios guardados',
  },
};
